

import React from 'react';
import { connect } from 'react-redux';
import { FaCheckCircle } from 'react-icons/fa';
import { setLoginPage, setForgetPasswordDetails, setSiteKey, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import SignUpComponent from './SignUpComponent';

class VoucherTransactionComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            verified: false,
            siteKey: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    onVerify = recaptchaResponse => {
        this.setState({
            verified: true
        });
    };

    fetchAccountDetails() {

        if (ValidateForm.inputFieldMandatoryCheck("otpCustomerIdContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("otpCustomerIdContainer", this.props.locales, false)) {
                this.props.setLoginPage("pageName", "amountForBillPay");
            }
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetUsernameOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetUsernameOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.voucherComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    voucherComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                <div className="col-md-12 row pt-5 m-0">

                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 mt-5" id="otpCustomerIdContainer">
                        <div className="col-md-12 text-center"><FaCheckCircle color="#7ED321" size="98" /></div>
                        <div className="col-md-12 pt-4 text-center p-0" style={{ fontSize: 30, color: '#404042', fontWeight: 600 }}>{this.props.locales.successMsgInVoucherTransactionPart}</div>
                        <div className="col-md-12 pt-3 text-center" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.anAmountofTextInVoucherTransactionPart}<span style={{ fontWeight: 600 }}>$10</span> {this.props.locales.creditedBalancetInVoucherTransactionPart}<span style={{ fontWeight: 600 }}>{this.props.userRegisterDetails.accountDetails.billingName} ({this.props.userRegisterDetails.accountDetails.accountId})</span> </div> </div>
                    <div className="col-md-1"></div>
                </div>
            </div>
        )
    }

    signInLinkClicked() {
        this.props.setLoginPage("pageName", "customerIdForOTP");
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        siteKey: state.siteKey,
        userRegisterDetails: state.userRegisterDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setSiteKey: function (key, payload) {
            dispatch(setSiteKey(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const VoucherTransactionComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(VoucherTransactionComponent)


export default VoucherTransactionComponentContainer;